<template>
  <div>
    <div class="invoice-basic">
      <van-cell-group v-show="invoiceInfo.invoiceCode" :border="false">
        <van-field
          label="发票代码"
        >
          <p slot="input" class="input">{{invoiceInfo.ocrInvoiceCode || invoiceInfo.invoiceCode}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo" :border="false">
        <van-field
          label="发票号码"
        >
          <p slot="input" v-if="invoiceInfo.invoiceNo" class="input">{{invoiceInfo.invoiceNo}}</p>
          <p slot="input" v-if="!invoiceInfo.invoiceNo" class="input">{{invoiceInfo.ocrInvoiceNo}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.timeGetOn" :border="false">
        <van-field
          label="上车时间"
        >
          <p slot="input" class="input">{{invoiceInfo.timeGetOn}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.timeGetOff" :border="false">
        <van-field
          label="下车时间"
        >
          <p slot="input" class="input">{{invoiceInfo.timeGetOff}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax" :border="false">
        <van-field
          label="发票金额"
        >
          <p slot="input" class="input" style="color: #2196F3;font-weight:bold">{{invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.drewDate" :border="false">
        <van-field
          label="开票日期"
        >
          <p slot="input" class="input">{{invoiceInfo.drewDate}}</p>
        </van-field>
      </van-cell-group>
    </div>
    <div class="divider-custom"></div>
    <van-cell-group :border="false">
      <van-field
        label="备注"
      >
        <div slot="input" class="input">{{invoiceInfo.remark}}</div>
      </van-field>
    </van-cell-group>
    <van-cell-group :border="false">
      <van-field
        label="标签"
      >
        <div slot="input" class="input">{{invoiceInfo.tag}}</div>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
import {
  CellGroup,
  Field,
  Divider
} from 'vant'
import { ConvertNumber } from '@utils/basicUtil'
export default {
  props: {
    invoiceInfo: {
      type: Object
    }
  },
  mounted () {
  },
  methods: {
    convertNumber (data) {
      return ConvertNumber(data)
    }
  },
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
